import { Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';

export function exportChassisCEMerchantTableColumns(): ColumnsType<
  Record<string, any>
> {
  const columns: ColumnsType<Record<string, any>> = [
    {
      title: 'Chassi',
      key: 'chassi',
      dataIndex: 'chassis',
      render: (value) => {
        return <div style={{ fontFamily: 'Consolas' }}>{value}</div>;
      },
      width: '40%',
    },
    {
      title: 'CE Mercante',
      dataIndex: 'merchant_ce',
      key: 'merchant_ce',
      render: (value) => {
        return <div style={{ fontFamily: 'Consolas' }}>{value}</div>;
      },
    },
  ];

  return columns;
}
